module.exports = __webpack_public_path__ + "static/media/practice-circles.5a3963e4.svg";